<template>
	<div>
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getRepairRecordUrl" @listData='getDeviceData'></MyPage>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
		<ColseModal @handleSubmit="handleSubmit" ref="ColseModal"></ColseModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './Template/FaultReportForm.vue';
	import infoModal from './Template/FaultReportModal.vue';
	import ColseModal from './Template/ColseReportModal.vue';
	import webapi from '../../../webapi.js';
	export default {
		components: {
			searchForm,
			infoModal,
			ColseModal
		},
		data() {
			return {
				getRepairRecordUrl: webapi.base_api_url + '/Maintenance/GetRepairRecord',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['运维服务', '>>', '故障报修'],
				//table标题数据
				columns1: [
					//Table普通实例
					{
						title: '报修时间',
						key: 'ApplyTime',
						minWidth: 130
					}, {
						title: '故障分类',
						key: 'FaultTypeDesc',
						minWidth: 100
					}, {
						title: '故障描述',
						key: 'FaultDesc',
						minWidth: 100
					}, {
						title: '当前状态',
						key: 'StatusDesc',
						minWidth: 100
					}, {
						title: '报修来源',
						key: 'ApplySourceDesc',
						minWidth: 100
					}, {
						title: '报人姓名',
						key: 'ApplyUserName',
						minWidth: 100
					}, {
						title: '报修人号码',
						key: 'ApplyPhoneNo',
						minWidth: 100
					}, {
						title: '设备编码',
						key: 'EquipmentNo',
						minWidth: 100
					}, {
						title: '所属场站',
						key: 'StationName',
						minWidth: 200
						// render: (h, params) => {
						// 	let stationName = ''
						// 	this.StationList.forEach(function(item) {
						// 		console.log(item);
						// 		if (item.StationId == params.row.StationId) {
						// 			stationName = item.StationName
						// 		}
						// 	})
						// 	return h('div', stationName)
						// }
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						minWidth: 160,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('closeOrder') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small',
										disabled: params.row.Status >= 12,
									},
									style: {
										marginRight: '5px',
									},
									on: {
										click: () => {
											this.show2('view', params.row)
										}
									}
								}, '关单') : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.show('view', params.row)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, '详情') : h(),
							]);
						}
					}
				],
				data: [],
				methodList: [{
					Id: 0,
					Status: '正常'
				}, {
					Id: 9,
					Status: '锁定'
				}, ]
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//  1-待处理；11-维修中；12-维修完成；98-审核不通过；99-审核通过
			closeRecord: function(Id) {
				this.$axios.post(webapi.base_api_url + "/Maintenance/SetRepairRecordStatus", {
					Id: Id,
					Status: 12
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.success('成功');
						this.handleSubmit();
					}
				}).catch(error => {
					this.$Message.error(error.response.data.Msg + "---" + error.response.data.Data);
				})
			},
			/******************组件固定方法*************************/
			show: function(type, params) {
				this.$refs.ItemModal.show(type, params)
			},
			show2: function(type, params) {
				this.$refs.ColseModal.show(type, params)
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 190;
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
